export default __webpack_public_path__ + "static/media/star.3954effd.svg";